import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardTitleComponent } from './card-title.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [CardTitleComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [CardTitleComponent]
})
export class CardTitleModule { }
